<script setup>
import { openSignInByEmailModal } from '@/helpers/modals.js'
  
function openModal () {
  openSignInByEmailModal()
}
</script>

<template>
  <div class="my-10 mx-auto max-w-md">
    <button
      type="button"
      class="btn btn-primary"
      @click="openModal">
      Open Modal
    </button>
  </div>
</template>